// Contract of ApiSessionExpiry: the server already reset the session and answers 401 with
// { error: 'session_expired', redirect_to }, so the page only has to navigate.
export const SESSION_EXPIRED = 'session_expired';

export function sessionExpiredRedirect(status, body) {
  if (status !== 401 || !body || body.error !== SESSION_EXPIRED) return null;

  return body.redirect_to || null;
}

// rails-ujs dispatches `ajax:error` with detail [parsedBody, statusText, xhr] for remote forms and links.
export function installSessionExpiredHandler(target, navigate) {
  target.addEventListener('ajax:error', (event) => {
    const [body, , xhr] = event.detail || [];
    const redirect = sessionExpiredRedirect(xhr && xhr.status, body);

    if (redirect) navigate(redirect);
  });
}
